module.exports = __webpack_public_path__ + "img/kehui.ba0621e9.png";